
export namespace CrudConstants {
  export const CRUD_MODE = {
    read: 'read',
    create: 'create',
    update: 'update',
    delete: 'delete',
  };
}
